import { render, staticRenderFns } from "./BaseMultiSelect.vue?vue&type=template&id=378b2088&"
import script from "./BaseMultiSelect.vue?vue&type=script&lang=js&"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseMultiSelect.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../GbR/10__Projekte/2021-04-26__Cumulus-Metadaten-Generator/03  App/v1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports